module.exports = __webpack_public_path__ + "img/ru.a475a1f6.svg";